module.exports = __webpack_public_path__ + "img/homeBg.ac40e66d.png";